import { Theme } from '@material-ui/core';
import { ThemeOptions } from '@material-ui/core/styles';

export const selectTheme = (theme: Theme): ThemeOptions => {
    const spacing2 = theme.spacing(2);
    const spacing3 = theme.spacing(3);
    return {
        overrides: {
            MuiSelect: {
                root: {
                    borderColor: '#78BADB',
                },
                outlined: {
                    padding: '3px',
                    border: `2px solid ${theme.palette.primary.main}`,
                    borderRadius: '2rem',
                    '&:focus-within, &:active, &:focus': {
                        borderColor: theme.palette.primary.main,
                        boxShadow: 'rgba(64, 143, 218, 0.25) 0 0 0 0.2rem',
                        borderRadius: '2rem',
                    },
                },
                select: {
                    padding: 16,
                    border: '1px solid #ADADAD',
                    '&:focus-within, &:active, &:focus': {
                        borderColor: theme.palette.primary.main,
                        boxShadow: 'rgba(64, 143, 218, 0.25) 0 0 0 0.2rem',
                        borderRadius: 4,
                    },
                    borderRadius: 4,
                    overflow: 'hidden',
                    '& .MuiInputBase-input': {
                        border: 'none',
                        fontWeight: 'bold',
                        paddingTop: spacing2,
                        paddingBottom: spacing2,
                        paddingLeft: spacing3,
                    },
                    '& .MuiInputBase-input:focus': {
                        border: 'none',
                        boxShadow: 'none',
                        backgroundColor: 'inherit',
                    },
                },
            },
        },
    };
};
